import React from 'react';
import Typography from '@material-ui/core/Typography';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { PlaystoreLogo, AppstoreLogo } from './logo';
import home from '../assets/home.jpg';
import calendar from '../assets/calendar.jpg';
import language from '../assets/language.jpg';
import places from '../assets/places.jpg';

const Home = () => {
  return (
    <Typography component='div' style={{ margin: 30, display: 'flex', flexDirection: 'column' }} >
      <Typography component='div' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }} >

        <Typography component='div' style={{ display: 'flex', flexDirection: 'column', flex: 0.4, textAlign: 'center', }} >

          <h2 style={{ fontFamily: 'Futura' }}>BroSolat</h2>
          <p>Bro Solat is an app that provides Prayer Time for states in Malaysia</p>
          <p>Currently, it is available in iOS only and is under development for Android </p>
          <p>BroSolat is a developing app. We are open to suggestions and feedback.</p>
          <p>and...</p>

          <p style={{ fontFamily: 'Futura' }}>Try dulu bro..</p>
          {/* <PlaystoreLogo style={{ margin: 10 }} /> */}
          <AppstoreLogo style={{ margin: 10 }} href={`https://apps.apple.com/us/app/bro-solat/id1490261953`} />
        </Typography >

        <Typography component='div' style={{ display: 'flex', flexDirection: 'row', flex: 0.6, justifyContent: 'center', flexWrap: 'wrap', marginTop: 50 }} >

          <Carousel width={250} autoPlay infiniteLoop={true} showThumbs={false} emulateTouch={true}>
            <img src={home} />
            <img src={calendar} />
            <img src={language} />
            <img src={places} />
          </Carousel>

        </Typography >
      </Typography >
    </Typography >
  )
}

export default Home